import { transformFirstTimeListerGuidlineDto } from 'data/transformers/first-time-lister-guideline'
import { FirstTimeListerGuidelineModel } from 'types/models/first-time-lister-guideline'

import { ConfigurationType } from '../types'
import {
  ItemUploadABTestDto,
  ItemUploadABTestModel,
  ItemUploadConfigurationPhotoTipDto,
  ItemUploadConfigurationPhotoTipModel,
  ItemUploadConfigurationDto,
} from '../types/configuration'

export const transformABTestDtoToModel = (dto: ItemUploadABTestDto): ItemUploadABTestModel => {
  return {
    testId: dto.test_id,
    testName: dto.test_name,
    countryCode: dto.country_code,
    testAnonId: dto.test_anon_id,
    testUserId: dto.test_user_id,
    variant: dto.variant,
  }
}

const transformItemConfigurationPhotoTipDto = ({
  message,
  action_title,
}: ItemUploadConfigurationPhotoTipDto): ItemUploadConfigurationPhotoTipModel => ({
  message,
  actionTitle: action_title,
})

export const transformItemUploadConfigDto = (
  dto: ItemUploadConfigurationDto,
): ConfigurationType => {
  const transformedABTests: { [key: string]: ItemUploadABTestModel } = {}
  let firstTimeListingGuideline: FirstTimeListerGuidelineModel | null = null

  if (dto.ab_tests) {
    Object.keys(dto.ab_tests).forEach(key => {
      if (dto.ab_tests?.[key]) {
        transformedABTests[key] = transformABTestDtoToModel(dto.ab_tests[key]!)
      }
    })
  }

  if (dto.first_time_lister_guideline) {
    firstTimeListingGuideline = transformFirstTimeListerGuidlineDto(dto.first_time_lister_guideline)
  }

  return {
    photoTip: dto.photo_tip ? transformItemConfigurationPhotoTipDto(dto.photo_tip) : null,
    uploadSessionId: dto.upload_session_id,
    catalogFieldsOrder: dto.catalog_group_fields,
    maxShippingPrice: dto.max_custom_shipping_price,
    abTests: transformedABTests,
    firstTimeListingGuideline,
    currency: dto.currency,
  }
}
